import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { distinctUntilChanged, switchMap, map, catchError, merge, of } from 'rxjs';
import { CourseApiService } from '../course-api.service';
import {
	fetchCourse,
	updateCourse,
	loadStateCourseFailure,
	fetchUniversity,
	updateUniversity,
	fetchClearingCourse,
	fetchClearingUniversity,
	updateClearingUniversity,
	updateClearingCourse,
} from './course.actions';

@Injectable()
export class StateCourseEffects {
	constructor(
		private readonly _actions$: Actions,
		private _courseApiSrv: CourseApiService,
	) {}

	fetchCourse = createEffect(() =>
		this._actions$.pipe(
			ofType(fetchCourse),
			distinctUntilChanged(),
			switchMap((payload) =>
				merge(of(null), this._courseApiSrv.getCourse(payload.courseSlug)),
			),
			map((payload) => updateCourse({ course: payload })),
			catchError((error) => of(loadStateCourseFailure(error))),
		),
	);

	fetchUniversity = createEffect(() =>
		this._actions$.pipe(
			ofType(fetchUniversity),
			distinctUntilChanged(),
			switchMap((payload) =>
				merge(
					of(null),
					this._courseApiSrv.getUniversity(payload.uniSlug, payload.product),
				),
			),
			map((university) => updateUniversity({ university })),
			catchError((error) => of(loadStateCourseFailure(error))),
		),
	);

	fetchClearingCourse = createEffect(() =>
		this._actions$.pipe(
			ofType(fetchClearingCourse),
			distinctUntilChanged(),
			switchMap((payload) =>
				merge(of(null), this._courseApiSrv.getClearingCourse(payload.courseSlug)),
			),
			map((payload) => updateClearingCourse({ clearingCourse: payload })),
			catchError((error) => of(loadStateCourseFailure(error))),
		),
	);

	fetchClearingUniversity = createEffect(() =>
		this._actions$.pipe(
			ofType(fetchClearingUniversity),
			distinctUntilChanged(),
			switchMap((payload) =>
				merge(
					of(null),
					this._courseApiSrv.getClearingUniversity(payload.uniSlug),
				),
			),
			map((payload) => updateClearingUniversity({ clearingUniversity: payload })),
			catchError((error) => of(loadStateCourseFailure(error))),
		),
	);
}
